'use strict';

var svaneTvis = svaneTvis || {};

svaneTvis.markedplace = svaneTvis.markedplace || new function () {
    // polyfill for closest
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector;
    }

    if (!Element.prototype.closest) {

        Element.prototype.closest = function (s) {
            var el = this;
            if (!document.documentElement.contains(el)) {
                return null;
            }
            do {
                if (el.matches(s)) {
                    return el;
                }
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }

    const apps = document.getElementsByClassName('js-marketplace');
    const body = document.querySelector('body');

    for(let i=0;i< apps.length;i+=1) {
        const app = apps[i];
        const shopName = app.getAttribute('data-shop-name').toLowerCase();
        new Vue({
            el: app,
            data: {
                shop: [],
                showModal: false,
                location: '*',
                currentModalData: [],
                itemtype: 'Product'
            },
            mounted() {
                this.itemtype = this.$el.dataset.marketplaceType==='cases'? 'Case':'Product';
                axios.get(marketplaceApiUrl + '?City=' + shopName)
                    .then((response) => {
                        this.shop = response.data.shop[0];
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },
            methods: {
                getShopItems(shop) {
                    if(shop.items === undefined) {
                        return undefined;
                    }
                    return shop.items.filter(item => item.itemType === this.itemtype);
                },
                openModal(item) {
                    this.currentModalData = item;
                    this.showModal = true;
                    this.$nextTick(() => {
                        // const carousel = document.querySelector(".main-carousel");
                        let flkty = new Flickity(this.$refs.carousel, {
                            contain: true,
                            adaptiveHeight: true,
                            pageDots: false,
                            lazyLoad: true
                        });
                    });
                    body.classList.add('no-scroll');

                },
                closeModal() {
                    this.showModal = false;
                    this.currentModalData = [];
                    body.classList.remove('no-scroll');

                },

                showText(event) {
                    this.animateHeight(event.target);
                },

                animateHeight(element) {
                    const elementWrapper = element.closest('.box__content');
                    const contentItem = elementWrapper.querySelector('.box__description');
                    const elementContent = contentItem.querySelector('.box__description-wrapper');
                    const showMoreText = element.getAttribute('data-show-more-text');
                    const showLessText = element.getAttribute('data-show-less-text');

                    if (elementContent != undefined) {
                        let elementContentHeight = elementContent.offsetHeight;
                        let newHeight;
                        let heightAttr = contentItem.dataset.height;

                        if (heightAttr === undefined) {
                            newHeight = contentItem.offsetHeight + elementContentHeight - 130;
                            contentItem.dataset.height = contentItem.offsetHeight;
                            contentItem.dataset.textShowMore = false;
                            element.closest('.box__content').classList.add('box__content--active');
                            element.innerHTML = showLessText;
                        } else {
                            if(contentItem.dataset.textShowMore === 'true'){
                                contentItem.dataset.textShowMore = false;
                                element.innerHTML = showLessText;
                            }else {
                                contentItem.dataset.textShowMore = true;
                                element.innerHTML = showMoreText;
                            }
                            if (heightAttr < contentItem.offsetHeight) {
                                newHeight = heightAttr;
                                element.closest('.box__content').classList.remove('box__content--active');
                            } else {
                                newHeight = contentItem.offsetHeight + elementContentHeight - 130;
                                element.closest('.box__content').classList.add('box__content--active');
                            }
                        }
                        contentItem.style.height = newHeight + 'px';
                    }
                }
            },
            computed: {
                shopsWithItems() {
                    const shops = [];
                    for (let i = 0; i < this.shop.length; i++) {
                        const shop = this.shop[i];
                        if (shop.items.length) {
                            shops.push(shop);
                        }
                    }
                    return shops;
                },
                shopList() {
                    let shopList = this.shop;
                    if (this.location !== '*') {
                        shopList = shopList.filter(s => s.shop.toLowerCase() === this.location.toLowerCase());
                    }
                    return shopList;
                },
                categories() {
                    let temp = this.shop;
                    const categories = [];

                    // Take all the items from all the shops, and merge them into one list
                    const shopItems = this.shopList.reduce((list, shop) => {
                        return list.concat(shop.items);
                    }, []);

                    temp.map(shop => {
                        shop.items.map(item => {
                            if (!categories.some(x => x.name === item.type)) {
                                // Check if any of the shops contains the category. If not disable the the filter option
                                const disabled = !shopItems.some(x => x.type == item.type);
                                if (item.type != '') {
                                    categories.push({
                                        name: item.type,
                                        disabled,
                                    });
                                }
                            }
                        });
                    });
                    return categories;
                },
            },
        });
    }
}(); 